module.exports = __webpack_public_path__ + "img/charity_pig.3bcbffe6.svg";